import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { AuthGate } from '@/components/AuthGate'
import { Layout } from '@/components/Layout'
import { DashboardPage } from '@/pages/Dashboard'
import { PortfolioPage } from '@/pages/Portfolio'
import { AppDetailPage } from '@/pages/AppDetail'
import { HostingSitesPage } from '@/pages/HostingSites'
import { PipelinePage } from '@/pages/Pipeline'
import { StrategyPage } from '@/pages/Strategy'
import { ChangelogPage } from '@/pages/Changelog'
import { SettingsPage } from '@/pages/Settings'
import { OperationsPage } from '@/pages/Operations'
import { ValueEngineeringPage } from '@/pages/ValueEngineering'
import { DeferredWorkPage } from '@/pages/DeferredWork'

const rootRoute = createRootRoute({
  component: () => (
    <AuthGate>
      <Layout>
        <Outlet />
      </Layout>
    </AuthGate>
  ),
})

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: DashboardPage })
const portfolioRoute = createRoute({ getParentRoute: () => rootRoute, path: '/apps', component: PortfolioPage })
const appDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/apps/$slug',
  component: AppDetailPage,
})
const hostingRoute = createRoute({ getParentRoute: () => rootRoute, path: '/hosting', component: HostingSitesPage })
const pipelineRoute = createRoute({ getParentRoute: () => rootRoute, path: '/pipeline', component: PipelinePage })
const strategyRoute = createRoute({ getParentRoute: () => rootRoute, path: '/strategy', component: StrategyPage })
const changelogRoute = createRoute({ getParentRoute: () => rootRoute, path: '/changelog', component: ChangelogPage })
const settingsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: SettingsPage })
const operationsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/operations', component: OperationsPage })
const valueRoute = createRoute({ getParentRoute: () => rootRoute, path: '/value', component: ValueEngineeringPage })
const deferredRoute = createRoute({ getParentRoute: () => rootRoute, path: '/deferred-work', component: DeferredWorkPage })

export const routeTree = rootRoute.addChildren([
  indexRoute,
  portfolioRoute,
  appDetailRoute,
  hostingRoute,
  pipelineRoute,
  strategyRoute,
  operationsRoute,
  valueRoute,
  deferredRoute,
  changelogRoute,
  settingsRoute,
])

export const router = createRouter({ routeTree, defaultPreload: 'intent' })
